<template>
  <!-- <slot name="main" v-bind="{ images, showImage }"></slot> -->
  <!-- <slot name="gallery" v-bind="{ images, showImage, imagesThumbs }"></slot> -->

  <div
    class="ProjectList__Item"
    v-for="(url, thumbIndex) in images"
    :key="thumbIndex"
    @click="showImage(thumbIndex + 1)"
  >
    <img :src="url" alt="" />
  </div>

  <div class="AwGallery" v-if="showModal" @click="closeImage()">
    <div class="AwGallery__Pic">
      <img :src="currentImage" @click.stop="" />
    </div>

    <span class="AwGallery__Close">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
      >
        <title>close</title>
        <g
          stroke-linejoin="miter"
          stroke-linecap="square"
          stroke-width=".5"
          fill="none"
          stroke="#fff"
        >
          <path d="M6.343 6.343l11.314 11.314m-11.314 0L17.657 6.343"></path>
        </g>
      </svg>
    </span>

    <span
      v-show="totalImages > 1"
      @click.stop="prevImage()"
      class="AwGallery__Prev"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
      >
        <title>chevron-left</title>
        <g
          stroke-linejoin="miter"
          stroke-linecap="square"
          stroke-width=".5"
          fill="none"
          stroke="#fff"
        >
          <path d="M14 18l-6-6 6-6"></path>
        </g>
      </svg>
    </span>

    <span
      v-show="totalImages > 1"
      @click.stop="nextImage()"
      class="AwGallery__Next"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
      >
        <title>chevron-right</title>
        <g
          stroke-linejoin="miter"
          stroke-linecap="square"
          stroke-width=".5"
          fill="none"
          stroke="#fff"
        >
          <path d="M10 6l6 6-6 6"></path>
        </g></svg
    ></span>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      currentImage: null,
      currentIndex: null,
      showModal: false,
      images: [
        "https://picsum.photos/id/1010/2000/2000",
        "https://picsum.photos/id/1004/2000/2000",
        "https://picsum.photos/id/1024/2000/2000"
      ]
    };
  },
  computed: {
    totalImages() {
      return this.images.length;
    },
    imagesThumbs() {
      const thumbs = this.images.filter((imgObj, index) => {
        return index > 0;
      });
      return thumbs;
    }
  },
  methods: {
    showImage(index) {
      this.showModal = true;
      this.currentIndex = index;
      this.currentImage = this.images[index];

      console.log(this.currentImage);
    },
    prevImage() {
      if (this.currentIndex === 0) {
        this.showImage(this.totalImages - 1);
      } else {
        this.showImage(this.currentIndex - 1);
      }
    },
    nextImage() {
      if (this.currentIndex >= this.totalImages - 1) {
        this.showImage(0);
      } else {
        this.showImage(this.currentIndex + 1);
      }
    },
    closeImage() {
      this.showModal = false;
      this.currentIndex = null;
      this.currentImage = null;
    }
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (!this.showModal) return;

      if (e.key === "Escape") {
        this.closeImage();
      }
      if (e.key === "ArrowLeft") {
        this.prevImage();
      }

      if (e.key === "ArrowRight") {
        this.nextImage();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.AwGallery {
  background: rgba(#000, 0.75);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.AwGallery__Pic {
  position: fixed;
  width: calc(100% - 150px);
  height: calc(100% - 20px);
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.AwGallery__Close {
  color: #fff;
  position: fixed;
  top: -20px;
  font-size: 55px;
  right: 15px;
  cursor: pointer;
}

.AwGallery__Prev {
  position: fixed;
  z-index: 1000;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 75px;
  cursor: pointer;
}

.AwGallery__Next {
  position: fixed;
  z-index: 1000;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 75px;
  cursor: pointer;
}
</style>
